 
  var textbox = jQuery('.hdt-header-search_form .hdt-search_input'),
  captionLength = 0,
  caption = '',
  search_term_number = 0,
  id = setTimeout(TypingEffect, 4000); //call once and set an Id so it can be cleared
    
  function TypingEffect() {
    const words = [
      "Halloween","Lemax","Lights","Haunted","Ghoul","Animated"
    ];
    if (search_term_number == 6) {
      search_term_number = 0;
    }
    caption = words[search_term_number];
    search_term_number++;
    clearTimeout(id); //clear first clearTimeout(TypingEffect, 600) call
    captionLength = 1; //start at 0
    id = setInterval(type, 50); //call type every 50ms
  }

  function type() {
	textbox.attr("placeholder", "Search for: " + caption.substring(0, captionLength++));
	//when finshed typing clear interval and start erasing
	if (captionLength === caption.length + 1) {
		clearInterval(id); //clear clearInterval(type, 50) 
		id = setTimeout(ErasingEffect, 1000); //start ErasingEffect call once after delay
	}
}

function ErasingEffect() {
	clearTimeout(id); //clear clearTimeout(ErasingEffect, 2000); call 
	captionLength = caption.length; //start at end
	id = setInterval(erase, 50); //call erase every 50ms
}

function erase() {
	textbox.attr("placeholder", "Search for: " + caption.substring(0, captionLength--));
	//when finshed erasing clear interval and call type
	if (captionLength < 0) {
		clearInterval(id); //clear clearInterval(erase, 50)
		id = setTimeout(TypingEffect, 1000); //start over
	}
}